import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { INumberStudentStaffRooms } from '../models/numberStudentStaffRooms';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class NumberStudentStaffRoomsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getNumberStudentStaffRooms(buildingId: string): Observable<{has_error: boolean, message: string, data: INumberStudentStaffRooms}> {
        const url = environment.apiBaseUrl + endpoints.getNumberStudentStaffRooms.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: INumberStudentStaffRooms}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateNumberStudentStaffRooms(buildingId: string, data: Partial<INumberStudentStaffRooms>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateNumberStudentStaffRooms.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
